import { createAction } from "@reduxjs/toolkit";

export const createNote = createAction("CREATE_NOTE");
export const noteType = createAction("note_type");
export const noteTitle = createAction("note_title");
export const noteTxt = createAction("note_txt");
